import type { ReactNode } from "react";
import { Badge } from "./Badge";

function confColor(v: number): string {
  if (v >= 0.85) return "var(--ods-conf-high)";
  if (v >= 0.7) return "var(--ods-conf-med)";
  return "var(--ods-conf-low)";
}

export function ConfidenceBadge({ value }: { value: number }) {
  const pct = Math.round(value * 100);
  return (
    <span className="ods-confidence" title={`Model confidence ${pct}%`}>
      <span className="ods-confidence__bar" aria-hidden="true">
        <span className="ods-confidence__fill" style={{ width: `${pct}%`, background: confColor(value) }} />
      </span>
      <span style={{ color: confColor(value) }}>{pct}%</span>
      <span className="ods-visually-hidden">confidence</span>
    </span>
  );
}

export interface Citation {
  contractId?: string;
  contractTitle?: string;
  locator: string;
  snippet: string;
}

export function CitationChip({ locator, onClick }: { locator: string; onClick?: () => void }) {
  return (
    <button type="button" className="ods-citation" onClick={onClick} title="View source passage">
      <span aria-hidden="true">§</span> {locator}
    </button>
  );
}

export function VerificationBadge({ state }: { state: string }) {
  if (state === "verified") return <Badge tone="success">Human verified</Badge>;
  return <Badge tone="warning">Unverified</Badge>;
}

export function AiGeneratedFlag({ children = "AI generated" }: { children?: ReactNode }) {
  return (
    <span className="ods-ai-flag" title="Generated by Contract AI. Review before relying on it.">
      <span aria-hidden="true">✦</span> {children}
    </span>
  );
}

export function FailClosedNotice({ message }: { message: string }) {
  return (
    <div className="ods-failclosed" role="status">
      <strong>No grounded answer.</strong> {message}
    </div>
  );
}
